import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Gift } from "lucide-react";

export default function GiftModal({ open, onOpenChange, onDone, balance = 0 }) {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [grams, setGrams] = useState(0.1);
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    setLoading(true);
    try {
      await api.post("/gift", {
        recipient_name: name.trim(),
        recipient_phone: phone.trim(),
        grams: Number(grams),
        message: msg,
      });
      toast.success("Gift sent (WhatsApp notification MOCKED)");
      onOpenChange(false);
      onDone && onDone();
      setName(""); setPhone(""); setGrams(0.1); setMsg("");
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setLoading(false); }
  };

  const insufficient = Number(grams) > Number(balance);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="gift-modal" className="max-w-md rounded-3xl bg-brand-ivory border-brand-line">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-brand-charcoal flex items-center gap-2">
            <Gift className="text-brand-primary" size={20} /> Gift Gold
          </DialogTitle>
        </DialogHeader>

        <div>
          <Label className="text-brand-charcoal text-sm font-semibold">Recipient name</Label>
          <Input data-testid="gift-name" value={name} onChange={(e) => setName(e.target.value)} className="mt-2 h-12 rounded-xl border-brand-line bg-brand-sand" />
        </div>
        <div>
          <Label className="text-brand-charcoal text-sm font-semibold">Recipient phone</Label>
          <Input data-testid="gift-phone" value={phone} onChange={(e) => setPhone(e.target.value)} className="mt-2 h-12 rounded-xl border-brand-line bg-brand-sand" />
        </div>
        <div>
          <Label className="text-brand-charcoal text-sm font-semibold">Grams to gift</Label>
          <Input
            data-testid="gift-grams"
            type="number"
            step="0.01"
            value={grams}
            onChange={(e) => setGrams(e.target.value)}
            className="mt-2 h-12 rounded-xl border-brand-line bg-brand-sand tabular-nums"
          />
          <div className="mt-1 text-xs text-brand-slate tabular-nums">Available: {Number(balance).toFixed(4)}g</div>
          {insufficient && <div className="text-xs text-brand-primary mt-1">Insufficient balance</div>}
        </div>
        <div>
          <Label className="text-brand-charcoal text-sm font-semibold">Message (optional)</Label>
          <Textarea data-testid="gift-message" value={msg} onChange={(e) => setMsg(e.target.value)} className="mt-2 rounded-xl border-brand-line bg-brand-sand" />
        </div>

        <Button
          data-testid="gift-submit"
          onClick={submit}
          disabled={loading || !name || !phone || !grams || insufficient}
          className="w-full h-14 rounded-full bg-brand-primary hover:bg-brand-primary-soft text-brand-ivory font-semibold shadow-card"
        >
          {loading ? "Sending…" : "Send Gift"}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
